module.exports = __webpack_public_path__ + "static/img/logo-anran.b2f7886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-anran.jpg
// module id = nt2O
// module chunks = 1